// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2649":"52d0ab37","5084":"615b6b3d","8500":"beba4aaa"}[chunkId] || chunkId) + "-" + {"528":"97a3155f705acac3","606":"955ca1fa89030f19","2649":"d8bb3c5438fe7f32","5084":"450a0749a095be01","5730":"3608687b79b93e6a","7554":"e78939916a115852","8500":"17835a7421dbc025"}[chunkId] + ".js";
};